var React = require('react');

function RedTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M95.22,14.87a9.88,9.88,0,0,1,5.86,16.07L73.8,63.47,46.53,96a9.88,9.88,0,0,1-16.85-3L15.14,53.15.61,13.27A9.87,9.87,0,0,1,11.6.16L53.41,7.51Z","style":{"fill":"#f44d4d"}}));
}

RedTriangle.defaultProps = {"viewBox":"0 0 103.39 99.53"};

module.exports = RedTriangle;

RedTriangle.default = RedTriangle;
